import axios from 'axios';
import { ApiResponse } from '@/types/ApiResponse';
import { GetCourseByTypeRequest } from '@/types/course/request/GetCourseByTypeRequest'
import { GetCourseByTypeResponse } from '@/types/course/response/GetCourseByTypeResponse';
import { ContentServiceBasePath } from '@/services/BaseServicePath';
import { UserServiceBasePath } from '@/services/BaseServicePath';
import { CourseTypeResponse } from '@/types/course/response/CourseTypeResponse'
import { UserCourseBase } from '@/types/course/request/UserCourseBase';
import { UserCourseResponse } from '@/types/course/response/UserCourseResponse';
import { TeacherResponse } from '@/types/teacher/response/TeacherResponse';
import { Section } from '@/types/course/response/Section';
import { Question } from '@/types/question/Question';
import { TimeOfSectionCreate, TimeOfSectionResponse } from '@/types/timeofsection/TimeOfSection'
import { UserAnswerCreate } from "@/types/question/UserAnswer"
import { Course } from '@/types/course/request/Course';
import { MetricsResponse } from '@/types/admin/MetricsResponse'
import { DefaultBucketRequest,BucketRequest } from '@/types/question/DefaultBucketRequest';
import { AiServiceBasePath } from '@/services/BaseServicePath';
import { Test, PageTestResponse } from '@/types/assessments/assessments/Test';
import { HldzyxqcsAssessmentDTO } from "@/types/assessments/assessments/HldzyxqcsAssessmentDTO"
import { PageRequest } from "@/types/assessments/request/PageRequest"
import { CareerRecommendation } from '@/types/assessments/assessments/CareerRecommendation'
import { HldAssessmentResult } from '@/types/assessments/assessments/HldAssessmentResult'
export class ContentService {
    // 静态方法
    get_courses_by_type =  async(getCourseByTypeRequest: GetCourseByTypeRequest)=>{
        const response = await axios.post<ApiResponse<GetCourseByTypeResponse>>(`${ContentServiceBasePath}/v1/course/getcoursesbytype`,getCourseByTypeRequest);
        return response.data;
    }
    
    get_courses = async(page: number,limit: number)=> {
        try {
            const response = await axios.get(ContentServiceBasePath + '/v1/course/getcourse', {
                params: {
                        page,
                        limit
                    }
            });
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }

    getcoursebelongcoursetype = async () => {
        try {
            const response = await axios.get<ApiResponse<CourseTypeResponse[]>>(ContentServiceBasePath+'/v1/course/getcoursebelongcoursetype');
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }
    
    collectionCourse = async (userCourseBase:UserCourseBase) => {
        const response = await axios.post<ApiResponse<UserCourseResponse>>(ContentServiceBasePath + '/v1/course/collection', userCourseBase);
        return response.data;
    }

    //根据课程id ，获取某个课程下的教师信息
    getCourseAllTeacherByCourseId = async (courseid: number)=> {
        try {
            const response = await axios.get<TeacherResponse[]> (
                ContentServiceBasePath + '/v1/teacher/getcourseallteacherbycourseid', {
                    params: {
                        courseid: courseid
                    }
                }
            );
            console.log(response);
            console.log(response.data);
            return response;
        } catch (error) {
            console.error("Error fetching teachers:", error);
            throw error;
        }
    };


    getCourseDetailInfo = async (courseid: number) => {
        try {
            const response = await axios.get(ContentServiceBasePath + '/v1/course/getcoursedetailinfo', {
                params:{
                    courseid:courseid
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }
    
    userCollectionCourseStatus = async (userCourseBase:UserCourseBase) => {
        const response = await axios.post<ApiResponse<boolean>>(ContentServiceBasePath + '/v1/course/usercollectioncoursestatus', userCourseBase);
        return response.data;
    }

    getSectionWithVideoUrl = async (courseid: number) => {
        try {
            const response = await axios.get<ApiResponse<Section[]>>(ContentServiceBasePath + '/v1/course/getsectionofvideonotnullbycourseid', {
                params:{
                    courseid:courseid
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }

    // 获取问题
    getQuestionsOfSection = async (userid:number,sectionid: number): Promise<ApiResponse<Question[]>> => {
        try {
            const response = await axios.get<ApiResponse<Question[]>>(
                ContentServiceBasePath+"/v1/question/get_questionsofsection",
                {
                    params: { "userid":userid,"sectionid":sectionid }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching questions:', error);
            throw error;
        }
    };

    saveOrUpdateTimeOfSection = async (data: TimeOfSectionCreate) => {
        try {
            const response = await axios.post<ApiResponse<TimeOfSectionResponse>>(ContentServiceBasePath + "/v1/course/addsectionoftime", data);
            console.log('Response:', response.data);
            return response.data;
        } catch (error) {
            console.error('Failed to save or update TimeOfSection:', error);
        
        }
    };

    getTimeOfSection = async (data: TimeOfSectionCreate) => {
        try {
            const response = await axios.post<ApiResponse<TimeOfSectionResponse>>(ContentServiceBasePath + "/v1/course/getsectionoftime", data);
            console.log('Response:', response.data);
            return response.data;
        } catch (error) {
            console.error('Failed to save or update TimeOfSection:', error);
        }
    };

    addUserAnswerCreate = async (useranswers: UserAnswerCreate[]) => {
        const payload = {
            useranswers: useranswers,
        };
        try {
            const response = await axios.post(ContentServiceBasePath + '/v1/question/add_useranswer', payload);
            return response.data;
        } catch (error) {
            console.error('Failed to add questions to section:', error);
            throw error;
        }
    }

    getUserCoursesDetail = async (userid: number) => {
        const response = await axios.get<ApiResponse<Course[]>>(ContentServiceBasePath + '/v1/course/getusercoursesdetail', {
            params: {
                userid:userid
            }
        });
        return response.data;
    }

    // 获取里程碑信息
    getMetrics = async () => {
        const response = await axios.get<ApiResponse<MetricsResponse>>(UserServiceBasePath + "/v1/userservice/getmetrics")
        return response.data
    }

    upload_vedio_complete = async (bucketRequest:BucketRequest) => {
        try {
        // http://localhost:8001/complete
        const response = await axios.post(AiServiceBasePath+'/complete',bucketRequest);
        return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }

    // 获取测评信息  
    getAssessmets = async (pageRequest:PageRequest) => {
         try {
            // http://localhost:8001/complete
            const response = await axios.post<ApiResponse<PageTestResponse>>(ContentServiceBasePath+'/v1/assessment/getassessments',pageRequest);
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }

    getAssessmentByID = async (assessmentID: number) => {
        try {
            // http://localhost:8001/complete
            const response = await axios.get<ApiResponse<Test>>(ContentServiceBasePath+'/v1/assessment/get_one_assessments', {
                params: {
                        assessmentID
                    }
            });
            console.log(response.data)
            return response.data;
            
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }
    //存储霍兰德职业测评结果
    addHldAssessment = async (hldzyxqcsAssessmentDTO:HldzyxqcsAssessmentDTO) => {
        try {
            // http://localhost:8001/complete
            const response = await axios.post<ApiResponse<HldzyxqcsAssessmentDTO>>(ContentServiceBasePath+'/v1/assessment/add_hldzycqcs_assessments',hldzyxqcsAssessmentDTO);
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }
    //存储霍兰德职业测评分析结果
    addCareerRecommendation = async (careerRecommendation:CareerRecommendation) => {
        try {
            // http://localhost:8001/complete
            const response = await axios.post<ApiResponse<CareerRecommendation>>(ContentServiceBasePath+'/v1/assessment/add_career_recommendation',careerRecommendation);
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }

    getCareerRecommendation = async (userid: number) => {
        try {
            // http://localhost:8001/complete
            const response = await axios.get<ApiResponse<HldAssessmentResult>>(ContentServiceBasePath + '/assessment/get_assessment_by_user', {
                params: {
                    userid
                }
            });
            return response.data;
        } catch (error) {
            console.error('Error adding teacher:', error)
            throw error
        }
    }


}

export const contentService = new ContentService()